/*global __CLIENT__*/
import PropTypes from 'prop-types';

import React, { Component } from 'react';
import { Link } from 'react-router';
import { Map } from 'immutable';
import '../../styles/SidebarRelationships.css';


export default class RelationshipCollapse extends Component {
  static propTypes = {
    currentProjectId: PropTypes.string,
    hiddenRelationships: PropTypes.instanceOf(Map),
    rel: PropTypes.instanceOf(Map),
    relKey: PropTypes.number,
  };

  constructor(props) {
    super(props);

    this._callback = this._callback.bind(this);
    this._callbackProducer = this._callbackProducer.bind(this);
    this._callbackConsumer = this._callbackConsumer.bind(this);
  }

  _callbackProducer() {
    const { rel } = this.props;
    const producerElementId = rel.getIn(['producer', 'id']);

    this._callback(producerElementId);
  }

  _callbackConsumer() {
    const { rel } = this.props;
    const consumerElementId = rel.getIn(['consumer', 'id']);

    this._callback(consumerElementId);
  }

  _callback(id) {
    const {
      callback,
    } = this.props;

    callback(id);
  }

  render() {
    const { rel, relKey, hiddenRelationships } = this.props;

    const consumerName = rel.getIn(['consumer', 'name']);
    const producerName = rel.getIn(['producer', 'name']);
    const relId = rel.get('id');

    const hidden = hiddenRelationships ? hiddenRelationships.get(relId) : null;

    return (<tr key={relKey} style={{cursor: 'pointer'}} className={hidden ? 'hidden' : null}>
      <td>
        <Link onClick={this._callbackProducer}>
          {producerName}
        </Link>
      </td>
      <td>
        <Link onClick={this._callbackConsumer}>
          {consumerName}
        </Link>
      </td>
    </tr>);
  }
}



// WEBPACK FOOTER //
// ./src/components/RightColumn/SidebarRelationshipListItem.js